import { ILink } from '../components/Sider/interface';
import { DomainSettingPage } from '../pages'

interface SectionWithComponent extends ILink {
    component?: React.FC,
    sourceUrl?: string,
    items?: SectionWithComponent[]
}

const testSEOsiteIds = [
  '4142239921',
  '9653177290',
  '8919893636', 
  '3045857029',
  '7914498500',
]



/**
 * TODO refactor plan
 * 
 * less /v4/site
 * merge href and path
 */

function getSideData(siteId: string, openedPluginRoute: any[] = []) {
    const seoData = {
      title: 'SEO优化',
      icon: 'SEO',
      href: `/v4/site/seo/optimize-test`,
      path: '/v4/site/seo/optimize-test/:siteId',
      items: [
          {
              title: '优化检测',
              href: `/v4/site/seo/optimize-test/${siteId}`,
              path: '/v4/site/seo/optimize-test/:siteId',
              sourceUrl: '//www.kuaizhan.com/v3/site/seo/optimize-test'
          },
          {
              title: 'TDK设置',
              href: `/v4/site/seo/tdk-settings/${siteId}`,
              path: `/v4/site/seo/tdk-settings/:siteId`,
              sourceUrl: '//www.kuaizhan.com/v3/site/seo/tdk-settings'
          },
          {
              title: '高级设置',
              href: `/v4/site/seo/advanced-settings/${siteId}`,
              path: '/v4/site/seo/advanced-settings/:siteId',
              sourceUrl: '//www.kuaizhan.com/v3/site/seo/advanced-settings'
          }
      ]
    }

    const sideData: SectionWithComponent[] = [
        {
            title: '数据统计',
            icon: 'statistics',
            href: `/v4/site/stat/${siteId}`,
            path: '/v4/site/stat/:siteId',
            sourceUrl: '/site/stat-v2'
        },
        {
            title: '站点设置',
            icon: 'sitesetting',
            href: `/v4/site/settings`,
            items: [
                {
                    title: '基本设置',
                    href: `/v4/site/settings/${siteId}`,
                    path: '/v4/site/settings/:siteId',
                    sourceUrl: '/site/settings'
                },
                {
                    title: '站点消息推送',
                    href: `/v4/site/push/${siteId}`,
                    path: '/v4/site/push/:siteId',
                    sourceUrl: '/site/push'
                },
                {
                    title: '绑定独立域名',
                    href: `/v4/site/domain/${siteId}`,
                    path: '/v4/site/domain/:siteId',
                    // sourceUrl: '/site/domain'
                    component: DomainSettingPage
                },
                {
                    title: 'META设置',
                    href: `/v4/site/seo-list/${siteId}`,
                    path: '/v4/site/seo-list/:siteId',
                    sourceUrl: '/site/seo-list'
                }
            ]
        },
        {
          title: 'SEO优化',
          icon: 'SEO',
          href: `/v4/site/seo/optimize-test`,
          path: '/v4/site/seo/optimize-test/:siteId',
          items: [
              {
                  title: '优化检测',
                  href: `/v4/site/seo/optimize-test/${siteId}`,
                  path: '/v4/site/seo/optimize-test/:siteId',
                  sourceUrl: '//www.kuaizhan.com/v3/site/seo/optimize-test'
              },
              {
                  title: 'TDK设置',
                  href: `/v4/site/seo/tdk-settings/${siteId}`,
                  path: `/v4/site/seo/tdk-settings/:siteId`,
                  sourceUrl: '//www.kuaizhan.com/v3/site/seo/tdk-settings'
              },
              {
                  title: '高级设置',
                  href: `/v4/site/seo/advanced-settings/${siteId}`,
                  path: '/v4/site/seo/advanced-settings/:siteId',
                  sourceUrl: '//www.kuaizhan.com/v3/site/seo/advanced-settings'
              }
          ]
        },
        {
            title: '插件后台',
            icon: 'plug-in',
            href: `/v4/site/plugin/${siteId}`,
            items: openedPluginRoute
        }, 
        {
            title: '电商管理',
            icon: 'e-commerce',
            href: `/shop-office/sites/${siteId}/shops-list`,
            linkType: 'outer'
        },
        {
            title: 'APP管理',
            icon: 'app1',
            href: `/pp/app/ver?site_id=${siteId}`,
            linkType: 'outer',
        },
        {
            title: '文章管理',
            icon: 'article',
            href: `/post/cover?site_id=${siteId}`,
            linkType: 'outer'
        },
        {
            title: '社区管理',
            icon: 'community',
            href: `/backendv1/forum-list?site_id=${siteId}`,
            linkType: 'outer'
        },
        {
            title: '用户管理',
            icon: 'user',
            href: `/user/?site_id=${siteId}`,
            linkType: 'outer'
        },
        {
            title: '素材管理',
            icon: 'material',
            href: `/v4/site/pic/${siteId}`,
            path: '/v4/site/pic/:siteId',
            sourceUrl: '/pic/'
        },
        {
            title: '公众号',
            icon: 'officialaccount',
            href: `/weixin/stat?site_id=${siteId}`,
            linkType: 'outer'
        }
    ]

    // 测试SEO
    // const _siteId = window.location.pathname.split('/').slice(-1)[0]
    // if (testSEOsiteIds.indexOf(_siteId) >= 0) {
    //     sideData.splice(2, 0, seoData)
    // }

    // 东苏旗定制后台管理入口
    if (siteId === '8795881828' || siteId === '4142239921') {
        sideData.push({
            title: '分站管理',
            icon: 'site',
            href: `/v3/customize/dsq/statistic`,
            linkType: 'outer'
        })
    }

    return sideData
}

function flatSideData(siteId: string): SectionWithComponent[] {
    const data = getSideData(siteId);
    // @ts-ignore
    return data.reduce((acc, cur) => cur.items ? acc.concat(cur.items.map(item => ({
        ...item,
        parentHref: cur.href
    // @ts-ignore
    }))) : acc.concat(cur), [])
}

export {
    flatSideData
}

export default getSideData;